<template>
   <div class="asset-wrapper" :class="{active: active, hidden_zone: isHidden, locked: locked}" :style="getZIndex">
      <div class="zone-label" :style="getZoneLabelStyle">Zone {{zone.id/1000}} {{zone.name}}</div>
      <div id="text_asset" class="asset-shadow" :style="style">
         <textarea :readonly="locked" @keyup="handleTextChange" class="textEditor" type="text" :value="zone.val" :style="zone.style" :maxlength="zone.char_count"></textarea>
      </div>
   </div>
</template>

<script>
import Zone from './Zone';

import { mapState, mapActions } from 'vuex';
export default {
   extends: Zone,

   created() {
      //setting line height to font for older instances
      if (this.zone.style.lineHeight == "0px") {
         this.zone.style.lineHeight = this.zone.style.fontSize;
      }
   },

   methods: {
      ...mapActions([
         'changeZoneText'
      ]),

      handleTextChange(e) {
         this.changeZoneText({zoneId: this.zone.id, text: e.target.value});
      }
   },
}
</script>

<style lang="scss">

.asset-wrapper {
   z-index: 1000;
}

.locked {
   .zone-label {
      display: none;
   }
}

#text_asset {
   position: absolute;

   textarea {
      width: 100%;
      height: 100%;
   }

   .textEditor {
      background: transparent;
      border-style: none;
      outline: none;
      vertical-align: text-top;
      padding: 0px;
      margin: 0px;
      width: 100%;
   }
}
</style>